<template>
  <div :class="spinnerMode">
    <ProgressSpinner animationDuration="1s" strokeWidth="5" />
  </div>
</template>

<script>
import { computed } from "vue";
import ProgressSpinner from "primevue/progressspinner";
export default {
  props: {
    mode: {
      type: String,
      required: true
    }
  },
  components: { ProgressSpinner },
  setup(props) {
    const spinnerMode = computed(() => {
      return {
        "fullscreen-center": props.mode === "full",
        "spinner-container": props.mode === "contained"
      };
    });

    return { spinnerMode };
  }
};
</script>
